export default __webpack_public_path__ + "static/media/gate1Klein.48dfaca8.jpg";